import { LegalShell, H2, P, UL } from "./LegalShell";
import { COMPANY } from "@/data/content";

export default function Terms() {
  return (
    <LegalShell
      testid="page-legal-terms"
      overline="Legal"
      title="Terms of Business"
      updated="Pending solicitor sign-off"
      seoDesc="TWORAY Ltd Terms of Business v1.0."
    >
      <P>These Terms of Business govern the provision of advisory services by {COMPANY.name} ("we", "us", "our") to our clients ("you"). By engaging us you agree to these terms, as supplemented by any Proposal or Statement of Work (SOW).</P>

      <H2>1. Services</H2>
      <P>We provide independent technology and cyber security advisory services. The specific scope, deliverables, fees and timescales for each engagement are set out in the applicable Proposal/SOW, which forms part of these terms.</P>

      <H2>2. Fees & payment</H2>
      <UL items={[
        "Package prices are quoted excluding VAT and are indicative, subject to scope confirmed in the SOW.",
        "Invoices are payable within 14 days of the invoice date unless otherwise agreed in writing.",
        "We may suspend services where invoices remain unpaid beyond the due date.",
      ]} />

      <H2>3. Client responsibilities</H2>
      <P>You agree to provide timely access to relevant information, systems and personnel reasonably required for us to deliver the services, and to ensure the accuracy of information supplied to us.</P>

      <H2>4. Independence</H2>
      <P>We are vendor-neutral and receive no commissions or kickbacks from third-party suppliers. Any recommendations are made solely in your interest.</P>

      <H2>5. Confidentiality</H2>
      <P>Each party will keep the other's confidential information secure and use it only for the purposes of the engagement. Mutual confidentiality may be formalised via our Mutual NDA.</P>

      <H2>6. Intellectual property</H2>
      <P>On full payment, you receive a licence to use deliverables for your internal business purposes. We retain ownership of our pre-existing methods, templates and know-how.</P>

      <H2>7. Liability</H2>
      <P>Our total aggregate liability arising out of or in connection with an engagement is limited to the fees paid for that engagement. We do not exclude liability where it is unlawful to do so.</P>

      <H2>8. Term & termination</H2>
      <P>Either party may terminate an engagement on written notice as set out in the SOW. You remain liable for fees for services performed up to the date of termination.</P>

      <H2>9. Governing law</H2>
      <P>These terms are governed by the laws of {COMPANY.jurisdiction} and subject to the exclusive jurisdiction of its courts.</P>
    </LegalShell>
  );
}
